import { ConfigMurucaAdvancedSearchLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Ricerca avanzata',
  resultsUrl: { it: '/risultati' },
  hasDynamicOptions: true,
  formConfig: {
    submitButton: {
      label: 'advancedsearch#submit',
    },
    resetButton: {
      label: 'advancedsearch#reset',
    },
    groups: [
      {
        id: 'group-global-search',
        sections: ['section-global'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_global',
          isOpen: true,
          showHeader: false,
        },
      },
      {
        id: 'group-opere',
        sections: ['section-opere'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_opere',
          isOpen: true,
          showHeader: true,
        },
      },
      {
        id: 'group-manoscritti',
        sections: ['section-manoscritti'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_manoscritti',
          isOpen: true,
          showHeader: true,
        },
      },
    ],
    sections: [
      {
        id: 'section-global',
        title: '',
        inputs: [
          {
            id: 'query-fulltext',
            type: 'text',
            data: {
              id: 'query-fulltext',
              label: 'advancedsearch#fulltext_text',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'resource-type',
            type: 'checkbox',
            label: 'advancedsearch#label_resource-type',
            state: {
              value: [
                'work',
                'manuscript',
              ],
            },
            data: {
              id: 'resource-type',
              classes: 'checkbox-query-fulltext',
              legend: '',
              checkboxes: [
                {
                  label: 'advancedsearch#label_work',
                  payload: 'work',
                  classes: 'checkbox-query-fulltext'
                },
                {
                  label: 'advancedsearch#label_manuscript',
                  payload: 'manuscript',
                  classes: 'checkbox-query-fulltext',

                },
              ],
            },
          },
        ],
      },
      {
        id: 'section-opere',
        title: '',
        inputs: [
          {
            id: 'query-title',
            type: 'text',
            data: {
              id: 'query-title',
              label: 'advancedsearch#label_title',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-editor',
            type: 'text',
            data: {
              id: 'query-editor',
              label: 'advancedsearch#label_editor',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'work_genere',
            type: 'select',
            data: {
              id: 'work_genere',
              label: 'advancedsearch#label_genere',
              payload: '',
              options: [
              ]
            }
          },
          {
            id: 'work_lingua',
            type: 'select',
            data: {
              id: 'work_lingua',
              label: 'advancedsearch#label_lingua',
              payload: '',
              options: [
              ]
            }
          },
          {
            id: 'work_forma',
            type: 'select',
            data: {
              id: 'work_forma',
              label: 'advancedsearch#label_forma',
              payload: '',
              options: [
              ]
            }
          },
          {
            id: 'query-data',
            type: 'text',
            data: {
              id: 'query-data',
              label: 'advancedsearch#label_data',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-edition',
            type: 'text',
            data: {
              id: 'query-edition',
              label: 'advancedsearch#label_edition',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-text',
            type: 'text',
            data: {
              id: 'query-text',
              label: 'advancedsearch#label_query_text',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-distance-value',
            type: 'select',
            data: {
              id: 'query-distance-value',
              label: 'advancedsearch#distance_value',
              payload: '',
              options: ['', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => ({
                value: number.toString(),
                label: number.toString(),
                disabled: false,
              })),
            },
          },
          {
            // Id non a piacere: deve combaciare con la chiave costruita dal MDW/WP per i
            // dynamic_options (content_type 'work' + key 'mrc_tei_place') e con il
            // search_group in advanced_search_config.ts (vedi docs/person_name.md).
            id: 'work_mrc_tei_place',
            type: 'select',
            data: {
              id: 'work_mrc_tei_place',
              label: 'advancedsearch#label_luoghi',
              payload: '',
              options: [
              ]
            }
          },
          {
            // Stesso pattern di work_mrc_tei_place sopra, sulla tassonomia mrc_tei_name
            // (person/org/population) — vedi docs/person_name.md.
            id: 'work_mrc_tei_name',
            type: 'select',
            data: {
              id: 'work_mrc_tei_name',
              label: 'advancedsearch#label_persone',
              payload: '',
              options: [
              ]
            }
          },
        ],
      },
      {
        id: 'section-manoscritti',
        title: '',
        inputs: [
          {
            id: 'query-cnmd',
            type: 'text',
            data: {
              id: 'query-cnmd',
              label: 'advancedsearch#label_cnmd',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'manuscript_struttura',
            type: 'select',
            data: {
              id: 'manuscript_struttura',
              label: 'advancedsearch#label_struttura',
              payload: '',
              options: [
                { value: '', label: '---' },
                { value: 'Unitario', label: 'Unitario' },
                { value: 'Composito con U.C. descritte', label: 'Composito con U.C. descritte' },
              ]
            }
          },
          {
            id: 'query-unita-codicologica',
            type: 'text',
            data: {
              id: 'query-unita-codicologica',
              label: 'advancedsearch#label_unita',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-storia-manoscritto',
            type: 'text',
            data: {
              id: 'query-storia-manoscritto',
              label: 'advancedsearch#label_storia_manoscritto',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-osservazioni-manoscritto',
            type: 'text',
            data: {
              id: 'query-osservazioni-manoscritto',
              label: 'advancedsearch#label_osservazioni_ms',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-descrizione-generale',
            type: 'text',
            data: {
              id: 'query-descrizione-generale',
              label: 'advancedsearch#label_descrizione_generale',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'manuscript_tipologia',
            type: 'select',
            data: {
              id: 'manuscript_tipologia',
              label: 'advancedsearch#label_tipologia',
              payload: '',
              options: [
                { value: '', label: '---' },
                { value: 'lettera', label: 'Lettera' },
                { value: 'biglietto', label: 'Biglietto' },
                { value: 'cartolina postale', label: 'Cartolina postale' },
                { value: 'allegato', label: 'Allegato' },
              ]
            }
          },
          {
            id: 'manuscript_natura',
            type: 'select',
            data: {
              id: 'manuscript_natura',
              label: 'advancedsearch#label_natura',
              payload: '',
              options: [
                { value: '', label: '---' },
                { value: 'Originale', label: 'Originale' },
                { value: 'Copia', label: 'Copia' },
                { value: 'Minuta', label: 'Minuta' },
              ]
            }
          },
        ],
      },
    ],
  },
} as ConfigMurucaAdvancedSearchLayout;
